import type { QueryClient } from "@tanstack/react-query";

export const homeQueryKeys = {
  aviList: ["avi-list"] as const,
  aviFavorites: ["avi-favorites"] as const,
  aviDeadline: ["avi-deadline"] as const,
  workflow: ["workflow"] as const,
};

const HOME_WORKFLOW_DEPENDENT_QUERY_KEYS = [
  homeQueryKeys.aviList,
  homeQueryKeys.aviFavorites,
  homeQueryKeys.aviDeadline,
  homeQueryKeys.workflow,
] as const;

export function invalidateHomeWorkflowQueries(queryClient: QueryClient) {
  return Promise.all(
    HOME_WORKFLOW_DEPENDENT_QUERY_KEYS.map((queryKey) =>
      queryClient.invalidateQueries({ queryKey })
    )
  );
}
